"use client";

import type { StrategyAllocationResponse } from "@/types/portfolio-builder.types";
import { getDemoPricing } from "@/utils/demoPricing";

interface Props {
  strategy: StrategyAllocationResponse;
}

function formatCurrency(n: number): string {
  return "$" + n.toLocaleString("en-US");
}

export function StrategyRecommendationCard({ strategy }: Props) {
  const pricing = getDemoPricing(strategy.slug);

  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-800 bg-gray-900/50 p-4">
      <div className="min-w-0 flex-1">
        <h4 className="truncate font-medium">{strategy.name}</h4>
        <p className="mt-0.5 text-xs text-gray-500">{strategy.slug}</p>
        {pricing && (
          <p className="mt-1 whitespace-nowrap text-xs text-gray-500">
            <span className="uppercase tracking-wider">Per unit</span>{" "}
            <span className="font-medium text-gray-300">{pricing.unitEquity}</span>{" "}
            <span className="text-gray-600">·</span> {pricing.tierLabel}
          </p>
        )}
      </div>
      <div className="flex items-center gap-6 text-sm">
        <div className="text-center">
          <div className="text-gray-500 text-xs">Units</div>
          <div className="font-medium">{strategy.units}</div>
        </div>
        <div className="text-center">
          <div className="text-gray-500 text-xs">Allocation</div>
          <div className="font-medium text-blue-400">
            {formatCurrency(strategy.allocation)}
          </div>
        </div>
        <div className="text-center">
          <div className="text-gray-500 text-xs">Weight</div>
          <div className="font-medium">{(strategy.weight * 100).toFixed(1)}%</div>
        </div>
      </div>
    </div>
  );
}
